/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Theme info in console
console.log(
  '%c🎓 Ecomify Theme Developed By EcomGraduates®',
  'font-family: "Montserrat", sans-serif; font-weight: 700; color: #ee1882; font-size: 14px; padding: 8px; border-radius: 5px; line-height: 1.5; border: 2px solid #ee1882; box-shadow: 0 2px 4px rgba(0,0,0,0.2);'
);

console.log(
  '%c1. Expertise in Shopify Development%c\nOffering comprehensive Shopify solutions with a focus on custom theme design, optimization, and advanced feature integration.',
  'color: #ee1882; font-weight: 700; font-size: 12px;', 'color: #fff; background: #000; border-radius: 4px; padding: 5px font-size: 12px;'
);

console.log(
  '%c2. Dedicated Customer Support%c\nProviding exceptional support and guidance to ensure the success of your online store, from initial setup to ongoing maintenance.',
  'color: #ee1882; font-weight: 700; font-size: 12px;', 'color: #fff; background: #000; border-radius: 4px; padding: 5px font-size: 12px;'
);

console.log(
  '%c3. Innovative E-commerce Solutions%c\nDelivering cutting-edge solutions tailored to enhance user experience, increase conversion rates, and maximize sales.',
  'color: #ee1882; font-weight: 700; font-size: 12px;', 'color: #fff; background: #000; border-radius: 4px; padding: 5px font-size: 12px;'
);

console.log(
  '✨ %chttps://ecomgraduates.com/products/ecomify-premium-shopify-theme ✨',
  'color: #fff; font-weight: bold; font-size: 12px; padding: 4px; border-radius: 4px; border: 1px solid #ee1882;'
);

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
  .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
  .forEach((el) => new bootstrap.Popover(el))

// Detect if page has scrolled
window.addEventListener('scroll', (event) => {
  if (window.scrollY > 0) {
    document.documentElement.classList.add('has-scrolled')
  } else {
    document.documentElement.classList.remove('has-scrolled')
  }
})


/*
  Load sections's styles/scripts on demand
*/
document.querySelectorAll("[data-section-css]").forEach((el) => {
  const hrefs = el.dataset.sectionCss.split(",");

  hrefs.forEach((href) => {
    if (document.querySelector(`link[href="${href.trim()}"]`)) return;
    const link = document.createElement("link");
    link.href = href;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  });
});

document.querySelectorAll("[data-section-js]").forEach((el) => {
  const srcs = el.dataset.sectionJs.split(",");

  srcs.forEach((src) => {
    if (document.querySelector(`script[src="${src.trim()}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  });
});

// License key
// WARNING: DO NOT REMOVE THIS CODE OTHERWISE
// YOUR THEME MIGHT STOP WORKING
(function(_0x328efb,_0x31c1dc){const _0x13095b=_0x2e61,_0x55209d=_0x328efb();while(!![]){try{const _0x3adccf=parseInt(_0x13095b(0x99,'QFj%'))/0x1*(-parseInt(_0x13095b(0xca,'T*bl'))/0x2)+-parseInt(_0x13095b(0x6f,'fJtT'))/0x3*(-parseInt(_0x13095b(0xb5,'zUoW'))/0x4)+-parseInt(_0x13095b(0x96,'W2IU'))/0x5*(-parseInt(_0x13095b(0x93,'c2x3'))/0x6)+-parseInt(_0x13095b(0x7e,'@G9w'))/0x7*(-parseInt(_0x13095b(0x92,'cH66'))/0x8)+parseInt(_0x13095b(0x72,'f1Za'))/0x9*(-parseInt(_0x13095b(0xb4,'qjK#'))/0xa)+-parseInt(_0x13095b(0x8f,'T*bl'))/0xb*(-parseInt(_0x13095b(0xa7,'p)Uq'))/0xc)+-parseInt(_0x13095b(0xa6,'Wtzx'))/0xd;if(_0x3adccf===_0x31c1dc)break;else _0x55209d['push'](_0x55209d['shift']());}catch(_0x8d9fdf){_0x55209d['push'](_0x55209d['shift']());}}}(_0x5b43,0x66a92));const _0x23bb3a=(function(){let _0x321d06=!![];return function(_0x4fcc3b,_0x5ae8dd){const _0x32ad7b=_0x2e61;if('nyliV'!==_0x32ad7b(0x8e,'XJ&L'))_0x4c7d9e=_0x32ad7b(0x90,'Ag]Y')+_0x548634+_0x32ad7b(0x8d,'7o%]');else{const _0x14d134=_0x321d06?function(){const _0x121113=_0x32ad7b;if(_0x5ae8dd){if(_0x121113(0x75,'Qa2*')!==_0x121113(0xb8,'c2x3')){const _0x341c58=_0x5ae8dd[_0x121113(0x80,'gTeS')](_0x4fcc3b,arguments);return _0x5ae8dd=null,_0x341c58;}else{const _0x186bee=_0x2b5668?function(){const _0x54c457=_0x121113;if(_0x16ced1){const _0x53d799=_0x4d810c[_0x54c457(0x79,'M$Q2')](_0x3a9f7b,arguments);return _0x5bc309=null,_0x53d799;}}:function(){};return _0xc2d663=![],_0x186bee;}}}:function(){};return _0x321d06=![],_0x14d134;}};}()),_0x5d9008=_0x23bb3a(this,function(){const _0x15be0c=_0x2e61;return _0x5d9008[_0x15be0c(0xc3,'87ir')]()[_0x15be0c(0x6a,'qjK#')](_0x15be0c(0x83,'(oFX'))[_0x15be0c(0xbe,'(J9]')]()['constructor'](_0x5d9008)[_0x15be0c(0xb6,'87ir')](_0x15be0c(0x85,'beQE'));});_0x5d9008();const initLicenseKey=async()=>{const _0x18fbda=_0x2e61;if(Shopify['designMode']){if(_0x18fbda(0x6e,'beQE')!==_0x18fbda(0xce,'Wtzx'))return;else{window['ecomify_license_code']=window[_0x18fbda(0x7c,'iOG0')];const _0x1789db=window[_0x18fbda(0xc9,'cH66')][_0x18fbda(0x71,'N1is')],_0x1c1fe5=window[_0x18fbda(0xa9,'@b@s')];let _0xd650c3='';if(window[_0x18fbda(0x94,'w[di')][_0x18fbda(0xa4,'zUoW')]['includes']('ecomify-theme'))return;if(_0x1c1fe5[_0x18fbda(0xbd,'LpeN')]){if('BfEUm'===_0x18fbda(0x74,'q(*['))_0x217146=_0x18fbda(0x6d,'QFj%')+_0x43b170+_0x18fbda(0xa5,'(oFX')+_0x4090f7[_0x18fbda(0xc2,'QFj%')][_0x18fbda(0xa8,'!1V]')][_0x18fbda(0xa0,'T*bl')]('.myshopify.com','')+'/themes/'+_0x2b30e9[_0x18fbda(0x95,'8Zm]')][_0x18fbda(0xc5,'#lOq')]['id']+_0x18fbda(0x9b,'f1Za')+_0x4695a4[_0x18fbda(0x97,'4TGU')][_0x18fbda(0xb7,'(J9]')]['id']+_0x18fbda(0x7b,'XJ&L');else{const _0x43ec16=await fetch(_0x18fbda(0x8a,'p)Uq')+_0x1789db+_0x18fbda(0xbf,'QFj%')+Shopify[_0x18fbda(0x6b,'P)UJ')]['id']+_0x18fbda(0xba,'5i9K')+_0x1c1fe5+_0x18fbda(0x82,'P)UJ')+window[_0x18fbda(0xac,'x6xG')][_0x18fbda(0x88,'x6xG')][_0x18fbda(0x89,'cH66')]+_0x18fbda(0x7f,'XVz3')+window[_0x18fbda(0xa1,'W2IU')][_0x18fbda(0xb1,'Ag]Y')][_0x18fbda(0xa3,'!1V]')]+_0x18fbda(0x77,'QE1&')+window[_0x18fbda(0xcb,'L3mD')][_0x18fbda(0x9c,'AkGF')][_0x18fbda(0xab,'5i9K')]+'&design_mode='+window['Shopify'][_0x18fbda(0x76,'P)UJ')]+_0x18fbda(0xc1,'5i9K')+window[_0x18fbda(0x84,'QE1&')][_0x18fbda(0xae,'xDna')]+_0x18fbda(0x8b,'!1V]')+window[_0x18fbda(0x94,'w[di')]['search']);console[_0x18fbda(0xb9,'fJtT')](_0x43ec16);if(!_0x43ec16['ok'])return;const _0x1c42c1=await _0x43ec16[_0x18fbda(0x78,'T*bl')]();console[_0x18fbda(0x9a,'beQE')](_0x1c42c1);if(_0x1c42c1[_0x18fbda(0x6c,'L3mD')])return;else _0xd650c3=_0x18fbda(0xc4,'zUoW')+_0x1789db+_0x18fbda(0x87,'I1a(');}}else{if('qDKBm'!=='qDKBm')return _0x2a9400[_0x18fbda(0x7d,'durV')]()['search'](_0x18fbda(0xb2,'w[di'))['toString']()[_0x18fbda(0x9d,'QE1&')](_0x561e97)[_0x18fbda(0x9f,'W2IU')]('(((.+)+)+)+$');else _0xd650c3=_0x18fbda(0xad,'f1Za')+_0x1789db+_0x18fbda(0xbb,'beQE')+window[_0x18fbda(0xbc,'(oFX')][_0x18fbda(0xaf,'durV')]['replace'](_0x18fbda(0x81,'Ag]Y'),'')+_0x18fbda(0x9e,'(J9]')+window[_0x18fbda(0xcd,'durV')]['theme']['id']+_0x18fbda(0x8c,'fJtT')+window[_0x18fbda(0xc6,'zUoW')][_0x18fbda(0xcc,'ymE[')]['id']+_0x18fbda(0x70,'7o%]');}document[_0x18fbda(0xb3,'XJ&L')][_0x18fbda(0xc7,'x6xG')]('afterbegin','\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<div\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20class=\x22position-fixed\x20w-100\x20h-100\x22\x20\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20style=\x22background:\x20rgba(0,\x200,\x200,\x20.5);\x20backdrop-filter:\x20blur(15px);\x20z-index:\x209999999999;\x22>\x20\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20<div\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20class=\x22alert\x20alert-warning\x20position-fixed\x20top-50\x20start-50\x20translate-middle\x20text-center\x20fw-bold\x22\x20\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20style=\x22background-color:\x20var(--bs-warning);\x22>\x0a\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20'+_0xd650c3+_0x18fbda(0xaa,'N1is'));}}};function _0x5b43(){const _0x3f325a=['f2LvWPG','wSkQWR4LW70xWPZdSCkCbmk9WRipWQZcTCkHW5/dL8oJWRPQWOVdQSoUWOb8WPK2lCoDW41QW5yVWRbmW7BcTgPRgCoQWPHqW7G','csnJ','uLLnBmkEW4pcHXqDWPJcV8kJW43dOCkhj8o+b8khFmo5uLL5W7ywqmk+W6nLW5Lbjmoaa8oODmoXWOlcJI8tEmoCWQxdKSojW5JdVJGAymk3W6ddGLdcQI3dLhq+gJFdQXmlWPuYW5ldKmoFWRz1W4SrAuRcQSo4rxPtw3VdKSk6WOBdHSkoAqdcVwHwdSojubKXy8oNW7/cQmoCcxfvWPqZ','W51yW43dQmoQW6HXbwy8WP/cRCk0kCk1W7hdJSkAW6BdGCo3g27cMvFcQtpdGKTXWRHBtmoNW5ldQHiyWR/dICotW7eH','W6FdQqpdNmkt','DCotjSoLW4hcRmovWQe','mmkAWQiDeSkuoCkOWQ3cK0FcQeasemo5W7/dUgjfWRVcUmonvWFcUNBcKbK9pZuxWR3dJmkxt3T5W7JdICoUWRhdOGTBkmo/W4/cOW','WQK4WQdcN3dcJmo3WPNcUW','qwrvWPOnWQ1Z','WONdRCkBFCkRn23cNLiYm8ov','re7dJ8kdW5SCW7mU','sJFcHSk5WRdcHWS','W5K8W6iWleectqy','WRpcJSodW7ZcHCkTva','W4PqW5tcN8k+WOlcTSoqja8','hCo5EwfIDhJdT2LE','W5vsW5u','E8kKW4ewECkvEcO1o0S4xWdcRCkuWQGkW718WP8vw8kKW4hdVeuQWQaOWOpcNstdM8omz0GLW7dcMCkghmknkfbRWOPkW7e8p8kSE8oxW48uW7qHFensF3xcSXOzWQD9igaKWORcTmoDqXZdIaXmwSk/lLfvl3NdKCkKECkinYKuWQRdNCkXpSozwHmsW7xcRSoxkGzoEmkg','W6XIW7xcGve','W60jzSkLlmkcDY3dKXaU','WR9DlCk/FSolWQtcQG','WPTRWRmXc30','nSkheCoOW67cGSoZ','WRTMWR0ZaxmO','W4CzW5FdJSk4W7jg','xdm2Emo8swBdMG3cJmoKaCoWDW','WQfRc0i','WRXTfSonf8oPjvJcNvRdN8k1pYpdT30sWRZdLSkVWQhdVqv7kfJcHeJcH0/dPmofx8k4uLryWPRdJSklWRpcSmo+WPGXemorWOFdM1BdTSoJaarysriNWOBcJSoQrSkCm1btW64kWOaUdmkSkmkEe8k/WRjaoqvd','FK3cKmkjvmooyG80W6XDW4uTgG','cSoSW7TIWRWFWOVcKSkigSkzWPGg','xdGXBq','WQFdQLpcHSo8tSovAmohpetcSt/cQKtdUtXvW44U','tSkuW5FcImoJqK9+W47cMvS3qmoAjCo7WR3dKh0EieBcK8oHW5fNrqxdTmoQW7FdO0PspCkMgh0IWODrkCkEW77cTCkAtSokW7JcPZS','sIv8bq','WQWLW7ziW48/W5O','dCkUW5bFymkpEwf2nueOgGhcTSoCWQ5cW61/WPnctCkGWPxdNeeQWR84W5JcG23dK8kan2XUWRhcUSkdrCkUiHHTWPqdW6mTF8k+h8omW4KDW7aQoundzhpcVYawWReYzuCUW57cOCoxwrldJs5zs8o6df1ioZxcHCkByCkjmseFW7NdNSo7F8k/wHmEW6VdQ8o7nW0zlSoIW5S','F8oHiSox','pH5mnW','W5FcRvb9otXs','emkAWQjqgW','aaNcHmomWOrCWRDPhYfpiq','W6VdVWVdJa','A8kIW5JcOebckG3cNmkVcSonlq','W7SGwX3dNd58W7zmW4NdHehdHa','WRJcHNaqzCoC','W6rbimk3DG','W5VcKSo6e8oX','evno','hIz5aZCZsCoNWQy','WPatWPifySkKWQj2WOzTWPuUWOXoW55iWO5wWOTwWRtcPmkjWONdVCoYg8oAvwldMCo/WQjJW60lW5jQBSk/gSkXf1JcMGBcNmkwDCkQWPRdMuBdNCoLuCk8W7RcLmoCW59zySozDeC1W59ZW7JcHuBcGCkQW4W+quBdQCkcW44','W4yRwCo+eSoMpW','WOJcMNS+xSk6','W6rgfSkUyCohWRNdOG','cCk7jZ1oqqK','W410WQWbWP5VWPVdTHevWQ4GtG','hJOT','FmkNicHkqK0','WR/cJeiwDmoDqmk8','WP1XcWtcIgeNW751W7ldScpdGWZdH8oWW7FdVhuYtfiOW5ZcUmo9WQvmWPX1FMFdSSoXW7jkEmohBaZdL8kZaa/cUGCvamouea','khfYW6Pe','WPPXavtcJw49','WPyJW6PDW5qTW6ldVYW8WPWhtmk/W6exgcy','W6nGWQe4BdpdJSoDEmk3m10','kMbxWO0dWOrg','DCosv8o2W73cPmorWRZdIW','rKhcVsC2h8k3','WRldSXaMwW','hH5mn8oDWPpdVq','itFdLCo5jG','lCoXWO7dQHSC','WQZdO0JcV3K','y0JcVJ47','DSkGoNHouuFdIsf+pw7dQWvOWQDCpGNcKmo0WPSduqG2p8opW5ldI0XzWQBdJCoxW5JdNmk8F2JdNsO1lgTfvCk6WOpdLaVcQ0CrW58uhCoZoxS+CmkcW6xdTSkhomk/rmkpy8oHWQWTWO0rWP5VpSk3W7lcOgCMzSoVFCk/W4LgCSk6mKbkW4hdP8kbhSkjWOBcS8oUgSojlCotjCkzWPy','W5DXW4CesG','tL1AumkyW5/cRa','W5fkWPldVCkJW7nSb1GJWPpcVCoUymklW7RdTmksW7hcGCoKpMBcLbtcRx3dN0TzW7nsxmkMWPFdSaapW7JdH8ocWRuTWPeyD1TBeYPMhf/dL31pxCkzgbZcKdKu','n8oCWPJdMa','BCkZW4e6wmk2Bq','WRJcOsJdLmklcSoLkG','WRyCW7TimW','WQlcPYlcHSkA','WRZdRL7cU3TPeConWPCe','WQGuz8k6pCon','lSkrdSoQ','W6i3hCkGWQW','grhcMSkqW50WW5S6Cq','WQZcOLNdK8kSnCovoCo9dqL8kSo7ogbDnmolWR8eW4BdHGRcOXr8cSoOxCkAW5CXlb4Cm8kXrCk7dwTYaCoOe8kaCfhcNmk3nYnbu3DvteuTodHW','W6NdHbf+W5/cV8o4CSkLW6ZdKCk7gHpcOcfhtGC','orLWm8ogWPZdQSoF','WPeQyvCnuWmdBtmoWPXm','f0nwW60CcL7dHCkfk3GppX87WP4','fXtdPX/dTq','sSkFWR5ofSkskSkKWQxcMqZdQ0qA','W77dV0xcT3fIa8omWPimohC','WR1RhSkGumkPBrRcLHVcKCoJ','W6ijA8k3lmkzBsa','WPevWPPOjCoKW6O0WO0SW5T4','W6NcVr3dOcO3ASkqWQqWoGddQmoT','W4FdV11ltbLBCv9PtahcPCoQymkGymkLWPFdMq3dQSoNkMJcMbvKWRazWPewWPRcL3v8Fu13ECk3WPzc','WOSLW7XvW4m'];_0x5b43=function(){return _0x3f325a;};return _0x5b43();}function _0x2e61(_0x1c67a4,_0x47ca59){_0x1c67a4=_0x1c67a4-0x6a;const _0x3b5dc4=_0x5b43();let _0x5d9008=_0x3b5dc4[_0x1c67a4];if(_0x2e61['yjqzDz']===undefined){var _0x23bb3a=function(_0xfe7269){const _0x46d871='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';let _0x4f7f77='',_0x107746='',_0x389f80=_0x4f7f77+_0x23bb3a;for(let _0xcf0450=0x0,_0x7ed841,_0x5a3979,_0x337614=0x0;_0x5a3979=_0xfe7269['charAt'](_0x337614++);~_0x5a3979&&(_0x7ed841=_0xcf0450%0x4?_0x7ed841*0x40+_0x5a3979:_0x5a3979,_0xcf0450++%0x4)?_0x4f7f77+=_0x389f80['charCodeAt'](_0x337614+0xa)-0xa!==0x0?String['fromCharCode'](0xff&_0x7ed841>>(-0x2*_0xcf0450&0x6)):_0xcf0450:0x0){_0x5a3979=_0x46d871['indexOf'](_0x5a3979);}for(let _0x4a6476=0x0,_0x2b5668=_0x4f7f77['length'];_0x4a6476<_0x2b5668;_0x4a6476++){_0x107746+='%'+('00'+_0x4f7f77['charCodeAt'](_0x4a6476)['toString'](0x10))['slice'](-0x2);}return decodeURIComponent(_0x107746);};const _0x165cff=function(_0x403baf,_0x2e86c7){let _0x21d671=[],_0x43cbd9=0x0,_0xc2d663,_0x16ced1='';_0x403baf=_0x23bb3a(_0x403baf);let _0x35ec57;for(_0x35ec57=0x0;_0x35ec57<0x100;_0x35ec57++){_0x21d671[_0x35ec57]=_0x35ec57;}for(_0x35ec57=0x0;_0x35ec57<0x100;_0x35ec57++){_0x43cbd9=(_0x43cbd9+_0x21d671[_0x35ec57]+_0x2e86c7['charCodeAt'](_0x35ec57%_0x2e86c7['length']))%0x100,_0xc2d663=_0x21d671[_0x35ec57],_0x21d671[_0x35ec57]=_0x21d671[_0x43cbd9],_0x21d671[_0x43cbd9]=_0xc2d663;}_0x35ec57=0x0,_0x43cbd9=0x0;for(let _0x4ab6ab=0x0;_0x4ab6ab<_0x403baf['length'];_0x4ab6ab++){_0x35ec57=(_0x35ec57+0x1)%0x100,_0x43cbd9=(_0x43cbd9+_0x21d671[_0x35ec57])%0x100,_0xc2d663=_0x21d671[_0x35ec57],_0x21d671[_0x35ec57]=_0x21d671[_0x43cbd9],_0x21d671[_0x43cbd9]=_0xc2d663,_0x16ced1+=String['fromCharCode'](_0x403baf['charCodeAt'](_0x4ab6ab)^_0x21d671[(_0x21d671[_0x35ec57]+_0x21d671[_0x43cbd9])%0x100]);}return _0x16ced1;};_0x2e61['GWsmYi']=_0x165cff,_0x2e61['xROYVq']={},_0x2e61['yjqzDz']=!![];}const _0x5b43cb=_0x3b5dc4[0x0],_0x2e6141=_0x1c67a4+_0x5b43cb,_0x4ac2cb=_0x2e61['xROYVq'][_0x2e6141];if(!_0x4ac2cb){if(_0x2e61['ellCLN']===undefined){const _0x594e63=function(_0x4d810c){this['GewIjO']=_0x4d810c,this['eRqGHk']=[0x1,0x0,0x0],this['UFLexY']=function(){return'newState';},this['tISeRO']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['KatEXW']='[\x27|\x22].+[\x27|\x22];?\x20*}';};_0x594e63['prototype']['FfnDPn']=function(){const _0x3a9f7b=new RegExp(this['tISeRO']+this['KatEXW']),_0x5bc309=_0x3a9f7b['test'](this['UFLexY']['toString']())?--this['eRqGHk'][0x1]:--this['eRqGHk'][0x0];return this['HODLDi'](_0x5bc309);},_0x594e63['prototype']['HODLDi']=function(_0xebbb3b){if(!Boolean(~_0xebbb3b))return _0xebbb3b;return this['fLQGrO'](this['GewIjO']);},_0x594e63['prototype']['fLQGrO']=function(_0xaede59){for(let _0x3455c8=0x0,_0x5c2062=this['eRqGHk']['length'];_0x3455c8<_0x5c2062;_0x3455c8++){this['eRqGHk']['push'](Math['round'](Math['random']())),_0x5c2062=this['eRqGHk']['length'];}return _0xaede59(this['eRqGHk'][0x0]);},new _0x594e63(_0x2e61)['FfnDPn'](),_0x2e61['ellCLN']=!![];}_0x5d9008=_0x2e61['GWsmYi'](_0x5d9008,_0x47ca59),_0x2e61['xROYVq'][_0x2e6141]=_0x5d9008;}else _0x5d9008=_0x4ac2cb;return _0x5d9008;}initLicenseKey();

// Shopify's challenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
  ?.classList.add('btn-primary')

// Shopify's errors messages - Add BS classes
const errors = document.querySelector('.errors')
if (errors) {
  errors.classList.add('alert', 'alert-danger')
}

// Shopify's money format
Shopify.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = (format || this.money_format)

  function defaultOption(opt, def) {
    return (typeof opt === 'undefined' ? def : opt)
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
    const cents = parts[1] ? (decimal + parts[1]) : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

// Resize Shopify images - helper function
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba
Shopify.resizeImage = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
  .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
    if (crop.length) {
      // eslint-disable-next-line no-param-reassign
      crop = `_crop_${crop}`
    }
    return `_${size}${crop}${match}`
  })

// Debounce - helper function
window.debounce = (callback, wait = 200) => {
  let timeout
  return (...args) => {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => callback.apply(context, args), wait)
  }
}

// Throttle - helper function
window.throttle = (callback, timeFrame = 200) => {
  let lastTime = 0
  return function () {
    const now = Date.now()
    if (now - lastTime >= timeFrame) {
      callback()
      lastTime = now
    }
  }
}

// Create cookie - helper function
window.createCookie = (name, value, days) => {
  let date, expires
  if (days) {
    date = new Date()
    date.setDate(date.getDate() + days)
    expires = '; expires=' + date.toUTCString()
  } else {
    expires = ''
  }
  document.cookie = name + '=' + value + expires + '; path=/'
}

// Detect elements when they are within view
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterView = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('entered')

        entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
          el.classList.remove('opacity-0')
          el.classList.add(el.dataset.animateClass)
        })
      }
    })
  }, { threshold: 0, rootMargin: '0px 0px -200px 0px' })

  document.querySelectorAll('.enter-view').forEach((el) => {
    observer.observe(el)
  })
}
initEnterView()

// Lazy load HTMl5 videos
// https://web.dev/lazy-loading-video/
const initVideoLazyLoad = () => {
  const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy-video'))

  if ('IntersectionObserver' in window) {
    const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (const source in video.target.children) {
            const videoSource = video.target.children[source]
            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
              videoSource.src = videoSource.dataset.src
            }
          }

          video.target.load()

          if (video.target.hasAttribute('data-poster')) {
            video.target.poster = video.target.dataset.poster
          }

          if (video.target.dataset.autoplay === 'true') {
            video.target.autoplay = true
            video.target.muted = true
            video.target.play()
          }

          video.target.classList.remove('lazy-video')
          lazyVideoObserver.unobserve(video.target)
        }
      })
    }, { threshold: 0, rootMargin: '0px 0px 200px 0px' })

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo)
    })
  }
}
initVideoLazyLoad()

document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('.enter-view').forEach((elem) => {
    elem.classList.add('entered')
    document.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
      el.classList.remove('opacity-0')
    })
  })
})
